import { Injectable } from '@angular/core';
import { ApiService, PagedResultGeneric, ApiCacheOptions } from 'src/app/shared';
import { NewsArticleDto } from './dto/news-article.dto';
import { NewsArticleSearchDto } from './dto/news-article-search.dto';

@Injectable({
  providedIn: 'root',
})
export class NewsArticleService {
  constructor(private _apiService: ApiService) {}

  get(articleId: number) {
    const cacheOptions = this._apiService.getDefaultApiCacheOptionsForNoCache();
    return this._apiService.get(`NewsArticle/${articleId}`, cacheOptions);
  }

  search(dto: NewsArticleSearchDto): Promise<PagedResultGeneric<NewsArticleDto>> {
    const cacheOptions = this._apiService.getDefaultApiCacheOptionsForNoCache();
    return this._apiService.getPaged('NewsArticles/Search', dto, cacheOptions);
  }

  create(dto: NewsArticleDto): Promise<number> {
    return this._apiService.post('NewsArticle', dto);
  }

  update(dto: NewsArticleDto): Promise<void> {
    return this._apiService.put(`NewsArticle/${dto.ArticleId}`, dto);
  }

  delete(id: number) {
    return this._apiService.delete(`NewsArticle/${id}`);
  }
}
